import { createRuntimeError, getErrorMessage } from "./useChatControllerHelpers.js";
export function createConversationActions(params) {
  const {
    store,
    runtimeRef,
    setRuntimeError,
    stopStreaming,
    conversationNavigationRequestIdRef,
    conversationLoadRequestIdRef
  } = params;
  async function loadConversationMessages(conversationId, options = {}) {
    conversationLoadRequestIdRef.current += 1;
    const requestId = conversationLoadRequestIdRef.current;
    const {
      resetWhenUndefined = true
    } = options;
    if (conversationId == null) {
      if (resetWhenUndefined) {
        store.resetMessages();
      }
      return;
    }
    if (!runtimeRef.current.adapter.listMessages) {
      return;
    }
    store.resetMessages();
    try {
      const result = await runtimeRef.current.adapter.listMessages({
        conversationId,
        direction: 'backward'
      });
      if (requestId !== conversationLoadRequestIdRef.current || store.state.activeConversationId !== conversationId) {
        return;
      }
      store.setMessages(result.messages);
      store.setHistoryState({
        cursor: result.cursor,
        hasMore: result.hasMore ?? false
      });
      store.setError(null);
    } catch (error) {
      if (requestId !== conversationLoadRequestIdRef.current || store.state.activeConversationId !== conversationId) {
        return;
      }
      setRuntimeError(createRuntimeError('HISTORY_ERROR', getErrorMessage('Unable to load conversation history.', error), 'history', true, true, {
        conversationId
      }));
    }
  }
  async function loadMoreHistory() {
    const conversationId = store.state.activeConversationId;
    if (!conversationId) {
      return;
    }
    try {
      let result;
      if (runtimeRef.current.adapter.listMessages) {
        result = await runtimeRef.current.adapter.listMessages({
          conversationId,
          cursor: store.state.historyCursor,
          direction: 'backward'
        });
      } else if (runtimeRef.current.adapter.loadMore) {
        result = await runtimeRef.current.adapter.loadMore(store.state.historyCursor);
      }
      if (!result) {
        return;
      }
      if (store.state.activeConversationId !== conversationId) {
        return;
      }
      store.prependMessages(result.messages);
      store.setHistoryState({
        cursor: result.cursor,
        hasMore: result.hasMore ?? false
      });
      store.setError(null);
    } catch (error) {
      if (store.state.activeConversationId !== conversationId) {
        return;
      }
      setRuntimeError(createRuntimeError('HISTORY_ERROR', getErrorMessage('Unable to load more message history.', error), 'history', true, true, {
        conversationId,
        cursor: store.state.historyCursor
      }));
    }
  }
  async function setActiveConversation(id) {
    if (store.state.activeConversationId === id) {
      return;
    }
    stopStreaming();
    conversationNavigationRequestIdRef.current += 1;
    store.setActiveConversation(id);
    await loadConversationMessages(id);
  }
  return {
    loadConversationMessages,
    loadMoreHistory,
    setActiveConversation
  };
}